import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    position: "absolute",
    transition: "opacity 0.3s ease 0.1s",
    pointerEvents: "all",
  },
  right: {
    bottom: "50%",
    top: "50%",
    right: "-15px",
  },
  bottomRight: {
    bottom: 0,
    right: 0,
  },
}));
